import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { NgxMatDateAdapter } from '@ngxmc/datetime-picker';
import { Store } from '@ngxs/store';
import { UiState } from '../state/ui.state';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
export class MatDateLocaleSyncService {
  private initialized = false;

  constructor(
    private dateAdapter: DateAdapter<unknown>,
    private ngxMatDateAdapter: NgxMatDateAdapter<unknown>,
    private languageService: LanguageService,
    private store: Store
  ) {}

  initialize(): void {
    if (this.initialized) {
      return;
    }

    this.initialized = true;
    this.syncLocale(this.languageService.getCurrentLanguage());
    this.store.select(UiState.language).subscribe((language: string) => {
      this.syncLocale(language);
    });
  }

  private syncLocale(language: string): void {
    const matDateLocale = this.languageService.getMatDateLocaleForLanguage(language);
    this.dateAdapter.setLocale(matDateLocale);
    this.ngxMatDateAdapter.setLocale(matDateLocale);
  }
}
